import type { ChecklistItem } from '../types/schema'

/**
 * Collect completion edges by checklist identity, not by rendered day. This
 * deliberately keeps a duration item's contribution to one event on the day
 * it is completed, even when calendar adapters render it on every span day.
 */
export const getNewlyCompletedChecklistIds = (
  previous: ReadonlyMap<string, boolean>,
  items: readonly Pick<ChecklistItem, 'id' | 'isCompleted'>[],
): string[] => {
  const emitted = new Set<string>()
  for (const item of items) {
    if (!previous.get(item.id) && item.isCompleted) emitted.add(item.id)
  }
  return [...emitted]
}
